import { render, staticRenderFns } from "./RecordButton.vue?vue&type=template&id=0584574b&scoped=true&"
import script from "./RecordButton.vue?vue&type=script&lang=js&"
export * from "./RecordButton.vue?vue&type=script&lang=js&"
import style0 from "./RecordButton.vue?vue&type=style&index=0&id=0584574b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0584574b",
  null
  
)

export default component.exports